import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'

import { framework_tool, utils_tool } from  '@/tool';
let { WizContainer, WizReduxTemplate } = framework_tool;
let { checkStrLength } = utils_tool;
class MessageTask extends WizContainer {

  componentName = 'MessageTask';

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        // add: this._handleCMD,
        // update: this._handleCMD,
        // delete: this._handleCMD,
        // enable: this._handleCMD,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(MessageTask);
